import { isEmpty } from 'lodash'
import React, { Component } from 'react'
import Auth from '../../modules/Authentication'
import { handleErrors, handleResponse } from '../../modules/Utils'
import { apiUrl } from '../../variables/index'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
const withUrlFetch = ({
  name,
  url,
  cache = true,
  forceFetch = false,
  dontFetch = false,
  payload = [],
}) => WrappedComponent => {
  return class extends Component {
    constructor(props) {
      super(props)
      this.suffix = 'dropdown'
      this.state = {
        fetching: false,
        data: [],
        itemName: `${name}_${url}_${this.suffix}`,
        cache: cache,
      }
      this.auth = new Auth()
    }

    read = () => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}${url}`, { headers })
        .then(handleErrors)
        .then(handleResponse)
    }
    fetch = async () => {
      this.setState({
        fetching: true,
      })
      let data = []
      if (!dontFetch) {
        data = await this.read()
        if (payload.length > 0) {
          data = [...data, ...payload]
        }
      }
      this.setState({
        fetching: false,
      })
      return data
    }
    cacheData = data => {
      try {
        sessionStorage.setItem(this.state.itemName, JSON.stringify(data))
      } catch (e) {
        sessionStorage.clear()
      }
    }
    clearCache = () => {
      sessionStorage.removeItem(this.state.itemName)
    }
    getCached = () => {
      return JSON.parse(sessionStorage.getItem(this.state.itemName))
    }
    getData = async ({ cache = this.state.cache, forceFetch = true }) => {
      if (cache === true) {
        if (!isEmpty(this.getCached()) && forceFetch !== true)
          this.setState({ data: this.getCached() })
        else {
          await this.clearCache()
          const data = await this.fetch()
          this.cacheData(data)
          this.setState({
            data,
          })
        }
      } else {
        await this.clearCache()
        let data = await this.fetch()
        this.setState({
          data,
        })
      }
    }

    async componentDidMount() {
      await this.getData({ cache, forceFetch })
    }

    render() {
      return (
        <WrappedComponent
          itemName={this.state.itemName}
          fetching={this.state.fetching}
          data={this.state.data}
          fetch={this.getData}
          {...this.props}
        />
      )
    }
  }
}

export default withUrlFetch
